// extracted by mini-css-extract-plugin
export default {"container":"PageFooter_container__NyBn4","logo":"PageFooter_logo__jaTUy","span":"PageFooter_span__kTuEq","sm":"PageFooter_sm__UkSrd"};